module.exports = __webpack_public_path__ + "components/tide-table/static/moon-first-quarter-1ebf54cd51bc35722a3478038ac66b45.svg";